import React from "react";

import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { v4 as uuid } from "uuid";

import { BorderLine } from "../styles";

interface ErrorMessageBarProps {
  errors: string[];
}

export const ErrorMessageBar: React.FC<ErrorMessageBarProps> = ({ errors }): JSX.Element => {
  const items = errors.map((error) => ({
    key: `error-${uuid()}`,
    problems: error,
  }));

  return (
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          <TableCell
            style={{
              padding: 0,
              borderTop: BorderLine,
            }}
          >
            Problems ({errors.length})
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item.key}>
            <TableCell>{item.problems}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
